import { isEmpty, isUndefined } from 'lodash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAdminUser } from '@pocapan/shared/utils/AdminUtils';
import useUserQuery from '../api/queries/useUserQuery';

function AdminProtected({ children }) {
  const navigate = useNavigate();

  const [isAuthorized, setIsAuthorized] = useState(false);

  const user = useUserQuery();

  useEffect(() => {
    const checkAdminAuth = async () => {
      try {
        const currentUserId = user?.userId;
        if (isUndefined(currentUserId)) {
          return setIsAuthorized(false);
        }

        if (isEmpty(currentUserId) || !isAdminUser(currentUserId)) {
          throw new Error('Admin authentication error.');
        }
        setIsAuthorized(true);
      } catch (_error) {
        alert('Not accessible page. Please contact admin');
        navigate('/onboarding');
      }
    };

    checkAdminAuth();
  }, [navigate, user]);

  if (!isAuthorized) {
    return <></>;
  }

  return children;
}

export default AdminProtected;
